import { createContext, useContext } from 'react';

type TabsValueContextValue = string;

const TabsValueContext = createContext<TabsValueContextValue | null | undefined>(null);

export const TabsValueProvider = TabsValueContext.Provider;

export const useTabsValue = (): TabsValueContextValue | undefined => {
  const context = useContext(TabsValueContext);
  if (context === null) {
    throw new Error('useTabsValue must be used within a TabsValueProvider');
  }
  return context;
};
